app.controller('aboutCtrl', function($scope,$mdDialog,$window) {

} );